<template>
  <div>
    <!-- Filter Start -->
    <div class="filter">
      <div class="row align-items-center">
        <div class="col-lg">
          <h2 class="page-title">Part Maker App</h2>
        </div>
        <div class="col-lg-2">
          <div class="input-group">
            <input
              class="form-control filterInput text-gray-light border-0"
              type="search"
              placeholder="Search"
              aria-label="Search"
              v-model="filter.search"
              @input="updateTable"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-light text-gray border-0 bg-white"
                type="button"
              >
                <i class="fa fa-search"></i>
                <!-- Assuming you're using Font Awesome for the magnifier icon -->
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6"></div>
        <div v-if="this.user.status === 1" class="col-lg-2">
          <router-link
            to="/dashboard/part-maker-app/create"
            class="btn btn-primary"
            style="color: white; text-decoration: none; width: 100%"
          >
            New User
          </router-link>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <div class="bg-white shadow box-content mt-4">
      <vue-app-part-maker-table
        class="ahm-table"
        :table_striped="false"
        api_url="/user-partmaker/list"
        :filter="filter"
        :buttons="vue_universal_table.buttons"
        :fields="vue_universal_table.fields"
        :update="vue_universal_table.update"
        sort_order="DESC"
        sort_by="id"
        @onEdit="editUser"
      ></vue-app-part-maker-table>
    </div>
  </div>
</template>

<script>
import debounce from "debounce";

export default {
  metaInfo: {
    title: "User Settings",
  },
  data() {
    return {
      user: this.$store.getters.currentUser,
      modal: {
        new: false,
        edit: false,
        editData: false,
      },

      filter: {
        search: "",
      },
      vue_universal_table: {
        // buttons: [{ title: "edit", class: "btn btn-outline-secondary" }],
        fields: [
          // {title:"Username", variable:"username"},
          // {title:"User Type", variable:"type"},
          // {title:"Status", variable:"status", class_condition : {
          //     'ACTIVE' : 'status-span bg-custom-green',
          //     'INACTIVE' : 'status-span bg-custom-red'
          // }},
          { title: "Username", variable: "username" },
          // { title: "User Type", variable: "type" },
          // { title: "Product", variable: "product_category" },
          {
            title: "Status",
            variable: "status",
            // formatter: function (value) {
            //   return value === "1" ? "Active" : "Inactive";
            // },
            class_condition: {
              ACTIVE: "status-span bg-custom-green",
              INACTIVE: "status-span bg-custom-red",
            },
          },
        ],
        update: 0,
      },
    };
  },
  created() {
    const user = this.$store.state.userData.userData;
    if (!user) {
      this.$router.push("/login");
      this.$swal.fire({
        title: "You have been logged out!",
        text: "Session logon has expired, please re-login to continue.",
        icon: "warning",
      });
    }

    if (this.user.status === 1) {
      this.vue_universal_table.buttons = [
        { title: "edit", class: "btn btn-outline-secondary" },
      ];
    }
  },
  components: {},
  mounted() {
    // console.log("current user:", this.user);
    // console.log("is super admin:", this.user);
  },
  methods: {
    editUser(editData) {
      let data = JSON.parse(editData);
      console.log("data from edit data:", data);

      // Navigate to the EditMuatPage.vue with the id of the record to edit
      this.$router.push({
        name: "UPart", //use name for router push
        params: { data },
      });
      // this.$router.push({ name: "UMuat", params: { id: idToEdit } });
    },
    updateTable: debounce(function (e) {
      this.vue_universal_table.update++;
      console.log("filter search:", this.filter.search);
    }, 500),
    // deleteUser (userId) {
    //     this.$swal.fire({
    //         title: 'Are you sure?',
    //         text: "You are about to end this (man/woman)'s whole career!",
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#3085D6',
    //         cancelButtonColor: '#D33',
    //         confirmButtonText: 'Delete'
    //     }).then((result) => {
    //         if (result.value) {
    //             this.$http.delete("/admin/update?id=" + userId)
    //             .then((resp)=>{
    //                 this.$swal.fire({
    //                     title : "Success!",
    //                     icon : "success",
    //                     type : "success",
    //                     text : `User has been successfully deleted`
    //                 })
    //             })
    //             .catch((error)=>{
    //                 console.log('%cerror DashboardUserUM.vue line:78 ', 'color: red; display: block; width: 100%;', err);
    //                 this.$swal.fire({
    //                     title : "Error!",
    //                     icon : "error",
    //                     type : "error",
    //                     text : err.response.data.message
    //                 })
    //             })
    //         }
    //     })
    // }
  },
};
</script>

<style>
.status-span span {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

.status-span.bg-custom-green span {
  background-color: #2ecc71;
  color: white;
}

.status-span.bg-custom-red span {
  background-color: #e74c3c;
  color: white;
}
</style>

<style scoped>
.page-title {
  font-size: 16px;
  font-weight: bold;
  margin: 0;
}

.box-content {
  border-radius: 10px;
  padding: 20px;
}

.btn-pretty {
  background-color: #dbebff;
  color: #267ce5;
}
.innerBox {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
}
.statsData {
  padding: 10px 7px;
}

.stats {
  font-size: 1.3rem;
  font-weight: 600;
}

.bg-kabupaten {
  background-color: darkorange;
}
.bg-kecamatan {
  background-color: blueviolet;
}
.bg-desakel {
  background-color: darkslategray;
}
.bg-tps {
  background-color: dodgerblue;
}

.column-region {
  height: 400px;
  overflow-y: scroll;
}
</style>

<style scoped>
.not-selected-button {
  color: #4b4b4b;
  background-color: #ffffff;
  border: none;
}
.horizontal-line {
  border-top: 1px solid #a2a2a2;
  margin: 5px 0;
  width: 100%;
  height: 1px;
}

.ahm-button-circular {
  width: 40px; /* Set the width and height to the same value for a perfect circle */
  height: 40px;
  border-radius: 50%; /* Makes the button circular */
  background-color: #d8e4ff; /* Sets the background color */
  padding: 10px 20px; /* Adjust padding to fit your content */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
}

.ahm-modal-description {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #2d2d2d;
  opacity: 1;
}

.ahm-modal-title {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #4b4b4b;
  opacity: 1;
}

.ahm-modal-body {
  /* Set a fixed width and height for the container, or use relative units like % if needed */
  width: 100%;
  height: 100%;
  overflow: hidden; /* Hide any overflowing content */
}

.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 45%; /* Could be more or less, depending on screen size */
}

.close {
  color: black;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>

<style>
.ahm-table thead tr th,
.table-title {
  font-weight: normal;
  color: #bcbcbc;
  text-align: left !important;
}

.ahm-table thead tr th,
.ahm-table tbody tr td {
  vertical-align: middle;
  font-size: 14px;
  text-align: left !important;
}

.ahm-table .no-border td {
  border: 0;
  padding: 5px;
}
</style>
